// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import _ from 'lodash';

// Interne Module
import { tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import { convertDate, createPaxAges } from '@/_helper/mapper';
import * as storage from '@/_helper/storage';

// Komponenten
import Documents from '@/pages/documents';

class TransferDetails extends Component {
    state = {
        loadingTransferOffers: true,
    };

    constructor(props) {
        super(props);

        this.errorHandling = this.errorHandling.bind(this);
    }

    componentDidMount() {
        this.setState(
            {
                bookingData: this.props.bookingData,
            },
            () => {
                if (this.state.bookingData) {
                    if (storage.get('transferOffers')) {
                        this.setState({ loadingTransferOffers: false });
                    } else {
                        this.transferRequest();
                    }
                }
            }
        );
    }

    transferRequest() {
        let searchParams = this.state.bookingData.data.searchParams;
        let hotelSupplier = '';
        let handlingSupplier = '';

        if (searchParams.adults > 0 && this.state.bookingData.allowTransfer) {
            const sendData = {
                requestType: 'searchExtra',
                travelType: 'transfer',
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                hotelCodeList: [searchParams.hotelCode],
                filterTags: [],
                departureTime: searchParams.transferDepartureTime,
                returnTime: searchParams.transferArrivalTime,
                amountAdults: searchParams.adults,
                clientId: 'customerarea',
                hotelSupplier: hotelSupplier,
                handlingSupplier: handlingSupplier,
            };

            axios({
                url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
            })
                .then((response) => response)
                .then((data) => {
                    let bookingData = this.state.bookingData;

                    if (bookingData) {
                        if (data && data.data?.data?.transferOffers) {
                            storage.set('transferOffers', {
                                data: data.data.data,
                            });
                        } else {
                            bookingData.data.allowTransfer = false;
                        }

                        storage.set('bookingData', bookingData);
                        this.setState({
                            bookingData: bookingData,
                            loadingTransferOffers: false,
                        });
                    } else {
                        this.setState((state) => {
                            state.bookingData.data.allowTransfer = false;
                            state.loadingTransferOffers = false;
                            return state;
                        });
                    }
                })
                .catch((error) => this.setState({ error, loadingTransferOffers: false }));
        } else {
            this.setState({ loadingTransferOffers: false });
        }
    }

    railAndFlyRequest() {
        let railAndFlyData = undefined;

        if (this.state.bookingData !== null && this.state.bookingData !== undefined) {
            if (this.state.bookingData.data.serviceInformation.railAndFly !== undefined) {
                railAndFlyData = this.state.bookingData.data.serviceInformation.railAndFly;
            }

            if (this.state.bookingData.bookedService !== undefined) {
                if (this.state.bookingData.bookedService.railAndFly !== undefined) {
                    railAndFlyData = [];
                    _.forEach(this.state.bookingData.bookedService.railAndFly, function (v) {
                        railAndFlyData.push(v.data);
                    });
                }
            }
        }

        return railAndFlyData;
    }

    errorHandling(props) {
        if (props) {
            this.setState({
                error: true,
            });
        }
    }

    getTransferStatus() {
        if (this.state.bookingData === undefined) {
            return false;
        }

        const { data } = this.state.bookingData;

        let tripStartsIntheNext30Days = tripStartCountdown(data.searchParams.depDate) <= 30;

        let transferStatus = 'transferNotBooked';
        switch (true) {
            case data.frontendParams.transferDetails !== undefined &&
                window.$content.mappingTransfer[data.frontendParams.transferDetails.tariff.toLowerCase()] !==
                    undefined &&
                (!tripStartsIntheNext30Days || data.frontendParams?.price?.open !== 0):
                transferStatus = 'transferWarning';
                break;
            case data.frontendParams.transferDetails !== undefined &&
                tripStartsIntheNext30Days &&
                data.frontendParams?.price?.open === 0 &&
                window.$content.mappingTransfer[data.frontendParams.transferDetails.tariff.toLowerCase()] !== undefined:
                transferStatus = 'transferDocument';
                break;
            default:
        }

        let railFlyStatus = 'railFlyWarning';
        switch (true) {
            case this.railAndFlyRequest() === undefined:
                if (data?.allowRailAndFly) {
                    railFlyStatus = 'railFlyNotBooked';
                } else {
                    railFlyStatus = 'railFlyNotAllowed';
                }
                break;
            case tripStartsIntheNext30Days && data.frontendParams?.price?.open === 0:
                railFlyStatus = 'railFlyDocument';
                break;
            default:
        }

        return {
            transferStatus: transferStatus,
            railFlyStatus: railFlyStatus,
        };
    }

    transferDetails(transferStatus) {
        const { data } = this.state.bookingData;

        return transferStatus === 'transferWarning' ? (
            <>
                <div
                    className="button-element button-ghost"
                    onClick={() => {
                        this.setState({
                            transferWarning: this.state.transferWarning ? !this.state.transferWarning : true,
                        });
                    }}>
                    Transferdetails ansehen
                </div>
            </>
        ) : transferStatus === 'transferDocument' ? (
            <>
                <Documents
                    name="traveldocument"
                    renderType="transfer"
                    label="Transferdetails ansehen"
                    label_loading="Transferdetails werden geladen"
                    link="true"
                    errorHandling={this.errorHandling}
                />
            </>
        ) : (
            <>
                {data.allowTransfer ? (
                    <Link
                        rel="noopener noreferrer"
                        to={'/transfer'}
                        target="_blank"
                        className="button-element button-ghost">
                        Transfer buchen
                    </Link>
                ) : (
                    <>Keine Transfer möglich</>
                )}
            </>
        );
    }

    railFlyDetails(railFlyStatus) {
        return (
            <>
                {railFlyStatus === 'railFlyWarning' ? (
                    <>
                        <div
                            className="button-element button-ghost"
                            onClick={() => {
                                this.setState({
                                    railFlyWarning: this.state.railFlyWarning ? !this.state.railFlyWarning : true,
                                });
                            }}>
                            Zugverbindung ansehen
                        </div>
                    </>
                ) : railFlyStatus === 'railFlyDocument' ? (
                    <Documents
                        name="traveldocument"
                        renderType="railAndFly"
                        label="Zugverbindung ansehen"
                        label_loading="Zugverbindung wird geladen"
                        link="true"
                        errorHandling={this.errorHandling}
                    />
                ) : (
                    <Link
                        rel="noopener noreferrer"
                        to={'/zug-zum-flug'}
                        target="_blank"
                        className="button-element button-ghost">
                        Zug buchen
                    </Link>
                )}
            </>
        );
    }

    render() {
        let transferStatus = this.getTransferStatus().transferStatus;
        let railFlyStatus = this.getTransferStatus().railFlyStatus;

        if (
            this.props.bookingState === 'OK' &&
            this.state.bookingData !== undefined &&
            this.state.bookingData.travelType === 'package' &&
            (railFlyStatus !== 'railFlyNotAllowed' || this.state.bookingData.data.allowTransfer)
        ) {
            return (
                <div className="item transfer">
                    <i className="material-symbols-outlined">airport_shuttle</i>
                    <div>
                        {this.state.loadingTransferOffers ? (
                            <div className="lazy-load-background">
                                <span></span>
                                <span></span>
                            </div>
                        ) : (
                            <>
                                <div>
                                    {(this.state.bookingData.data.allowRailAndFly ||
                                        railFlyStatus !== 'railFlyNotAllowed') && (
                                        <>
                                            {railFlyStatus === 'railFlyNotBooked' ? 'Ohne ' : 'Mit '}
                                            Zug zum Flug
                                        </>
                                    )}
                                    {(this.state.bookingData.data.allowTransfer ||
                                        transferStatus !== 'transferNotBooked') && (
                                        <>
                                            {(this.state.bookingData.data.allowRailAndFly ||
                                                railFlyStatus !== 'railFlyNotAllowed') && <>&nbsp;&middot;&nbsp;</>}
                                            {transferStatus === 'transferNotBooked' ? 'Ohne ' : 'Mit '} Transfer
                                        </>
                                    )}
                                </div>

                                <div className="user-interaction">
                                    {(this.state.bookingData.data.allowRailAndFly ||
                                        railFlyStatus !== 'railFlyNotAllowed') && (
                                        <>{this.railFlyDetails(railFlyStatus)}</>
                                    )}

                                    {(this.state.bookingData.data.allowTransfer ||
                                        transferStatus !== 'transferNotBooked') && (
                                        <>{this.transferDetails(transferStatus)}</>
                                    )}
                                </div>

                                {railFlyStatus === 'railFlyWarning' && this.state.railFlyWarning && (
                                    <div className="booking-alert transport-details">
                                        <i className="material-symbols-outlined">info</i>
                                        Sie können Ihre Details zur Zugverbindung in Ihren Reiseunterlagen nachlesen.
                                        Diese werden frühesten 30 Tage vor Abreisedatum bei vollständiger Zahlung der
                                        Buchung angezeigt.
                                        <i
                                            className="icon-close material-symbols-outlined"
                                            onClick={() => {
                                                this.setState({ railFlyWarning: false });
                                            }}>
                                            close
                                        </i>
                                    </div>
                                )}
                                {(this.state.bookingData.data.allowTransfer ||
                                    transferStatus !== 'transferNotBooked') &&
                                    this.state.transferWarning && (
                                        <div className="booking-alert transport-details">
                                            <i className="material-symbols-outlined">info</i>
                                            Sie können Ihre Details zum Transfer in Ihren Reiseunterlagen nachlesen.
                                            Diese werden frühesten 30 Tage vor Abreisedatum bei vollständiger Zahlung
                                            der Buchung angezeigt.
                                            <i
                                                className="icon-close material-symbols-outlined"
                                                onClick={() => {
                                                    this.setState({ transferWarning: false });
                                                }}>
                                                close
                                            </i>
                                        </div>
                                    )}
                                {this.state.error && (
                                    <div className="booking-alert transport-details">
                                        <i className="material-symbols-outlined">info</i>
                                        Hier ist wohl etwas schiefgelaufen! Bitte versuchen Sie es erneut oder wenden
                                        Sie sich an unser Serviceteam.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            );
        }
    }
}

export default TransferDetails;
